import { Card, Image, Text, Group, Badge, Menu, ActionIcon, Anchor, Stack, rem } from '@mantine/core';
import { IconCalendar, IconDotsVertical, IconTrash, IconEdit, IconRepeat, IconCalendarPlus } from '@tabler/icons-react';
import { Link } from '@inertiajs/react';
import { useUser } from '../../src/context/UserContext';

export function RecurringEventCard({ recurringEvent, upvotedEvents }: any) {
  const hasImage = !!recurringEvent.image_url;
  const { user } = useUser();

  const formattedDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) === '12:00 AM'
      ? date.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })
      : date.toLocaleString(undefined, {
          weekday: 'short',
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        });
  };

  return (
    <Card
      shadow="sm"
      padding={0}
      radius="md"
      withBorder
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        position: 'relative',
        backgroundColor: '#fff7ed1a',
        border: '1px solid #f2f2f230',
      }}
    >
      <Card.Section>
        <Link href={`/re/${recurringEvent.slug}`} style={{ display: 'block' }}>
          <Image
            src={hasImage ? recurringEvent.image_url : 'https://dancewise.s3.amazonaws.com/Blank+Event+Image.png'}
            alt={recurringEvent.title}
            height={200}
            fit="cover"
          />
        </Link>
      </Card.Section>

      <Stack mt="xs" gap="xs" px="md" pb="xs" style={{ flexGrow: 1 }}>
        <Text fw={500} truncate="end" c="white">
          {recurringEvent.name}
        </Text>

        <Group gap="xs">
          <Badge
            variant="light"
            color="orange"
            size="lg"
            leftSection={<IconRepeat size={12} />}
            style={{ textTransform: 'capitalize' }}
          >
            {recurringEvent.frequency} Event: {recurringEvent.num_occurrences}
          </Badge>
        </Group>
      </Stack>
    </Card>
  );
}

export default RecurringEventCard;
